import React from 'react';
import { Input, Textarea, Select, Button, PaperClip, DatePicker } from 'components';
import moment from 'moment';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { Menu as MenuIcons, CompanyIcon } from 'assets/icons';
import { RouteComponentProps } from 'react-router-dom';
import { InformationService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Retargeting extends React.Component<Props> {

	state = {
		form: {
			retargeting_message: '1',
			autoresponse_time: '',
			retargeting: false
		},
		agents: []
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await InformationService.getData({
			user_id: this.props.user?.id
		});
		if (res.person?.autoresponse_time > 0) {
			res.person.autoresponse_time = res.person?.autoresponse_time / 60;
		}
		this.setState({
			agents: res.agents || [],
			form: {
				...this.state.form,
				retargeting_message: res.person?.retargeting_message || '',
				autoresponse_time: res.person?.autoresponse_time || '',
				retargeting: res.person?.retargeting || false
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		await InformationService.saveRetargeting({
			...this.state.form
		});
		Globals.showSuccess("Se ha modificado correctamente");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	render() {
		return (
			<div id="client-agent-retargeting">
				<form onSubmit={ this.submit } className="form-black">
					<div className="container-title">
						<div className="row">
							<div className="col-md-6" style={{ display: 'flex', alignItems: 'center' }}>
								<p>Crea mensajes personalizados para reactivar clientes y aumentar tus ventas</p>
							</div>
							<div className="col-md-6 text-right">
								<div className="check-container" onClick={ () => this.setState({
									form: {
										...this.state.form,
										retargeting: !this.state.form.retargeting
									}
								}) }>
									<p>{ this.state.form.retargeting ? 'Encendido' : 'Apagado' }</p>
									<div className={ `check ${ this.state.form.retargeting ? 'active' : '' }` }>
										<div className="check-circle"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="container-black">
						<div className="row">
							<div className="col-md-6" style={{ display: 'flex', alignItems: 'center' }}>
								<p className={ `message ${ !this.state.form.retargeting ? 'disabled' : '' }` }>Tu agente IA volverá a contactar a tu cliente</p>
							</div>
							<div className="col-md-6 text-right">
								<div className="container-hours">
									<p className={ !this.state.form.retargeting ? 'disabled' : '' }>Hora(s)</p>
									<Input
										disabled={ !this.state.form.retargeting }
										type="number"
										value={ this.state.form.autoresponse_time }
										name="autoresponse_time"
										placeholder="Horas"
										onChange={ (e: any) => this.change(e) } />
								</div>
							</div>
						</div>
					</div>
					<div className="container-title gray">
						<p className={ !this.state.form.retargeting ? 'disabled' : '' }>Contacta al cliente con este mensaje después del último contacto</p>
					</div>
					<Textarea
						disabled={ !this.state.form.retargeting }
						rows={ 6 }
						value={ this.state.form.retargeting_message }
						name="retargeting_message"
						placeholder="Escribir"
						onChange={ (e: any) => this.change(e) } />
					<Button type="submit">
						Guardar
					</Button>
				</form>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Retargeting);